module.exports = __webpack_public_path__ + "static/media/node-js-brands.cdc525fe.svg";